class MindboxManager {
    constructor() {
        if (MindboxManager.instance) {
            return MindboxManager.instance;
        }

        this.favorites = new Set();
        this.productPrices = new Map();
        this.isInitialized = false;
        MindboxManager.instance = this;
        this.init();
    }

    init() {
        if (this.isInitialized) {
            return;
        }
        this.loadFavoritesFromStorage();
        this.setupEventListeners();
        this.trackCategoryView();
        this.isInitialized = true;
    }

    addFavoritesProduct(productId, price) {
        this.favorites.add(productId);
        this.productPrices.set(productId, String(parseFloat(price) || '0'));
        this.saveFavoritesToStorage();
        this.addFavoritesListToMindbox();
        this.addFavoriteItemToMindbox(productId);
    }

    removeFavoritesProduct(productId) {
        this.favorites.delete(productId);
        this.productPrices.delete(productId);
        this.saveFavoritesToStorage();

        this.deleteFavoriteItemToMindbox(productId);
        if (this.favorites.size === 0) {
            this.deleteFavoritesListToMindbox();
        }
    }

    addFavoriteItemToMindbox(productId) {
        /* global mindbox */
        mindbox('async', {
            operation: 'YUntolovoDobavlenieVIzbrannoe',
            data     : {
                product: {
                    ids: {
                        website: String(productId)
                    }
                }
            },
            onError(error) {
                console.error('Mindbox error:', error);
            }
        });
    }

    addFavoritesListToMindbox() {
        const productList = Array.from(this.favorites).map((productId) => {
            return {
                product: {
                    ids: {
                        website: String(productId)
                    }
                },
                count       : 1,
                pricePerItem: String(this.productPrices.get(productId) || '0')
            };
        });

        mindbox('async', {
            operation: 'UstanovkaSpiskaIzbrannogoYu',
            data     : {
                productList
            },
            onError(error) {
                console.error('Mindbox error:', error);
            }
        });
    }

    deleteFavoriteItemToMindbox(productId) {
        mindbox('async', {
            operation: 'YUntolovoUdalenieIzIzbrannogo',
            data     : {
                product: {
                    ids: {
                        website: String(productId)
                    }
                }
            },
            onError(error) {
                console.error('Mindbox error:', error);
            }
        });
    }

    deleteFavoritesListToMindbox() {
        mindbox('async', {
            operation: 'OchistkaIzbrannogoYu',
            data     : {}
        });
    }

    saveFavoritesToStorage() {
        const data = {
            favorites: Array.from(this.favorites),
            prices   : Array.from(this.productPrices.entries()).map(([id, price]) => {
                return [id, String(price)];
            })
        };

        localStorage.setItem('favorites', JSON.stringify(data));
    }

    loadFavoritesFromStorage() {
        const saved = localStorage.getItem('favorites');

        if (saved) {
            const data = JSON.parse(saved);

            this.favorites = new Set(data.favorites || []);
            this.productPrices = new Map((data.prices || []).map(([id, price]) => {
                return [id, String(price)];
            }));
        }
    }

    setupEventListeners() {
        document.addEventListener('click', (event) => {
            const favButton = event.target.closest('.j-favorite[data-offer-id]');

            if (favButton) {
                event.preventDefault();
                this.handleFavoriteClick(favButton);
            }
        });
    }

    handleFavoriteClick(button) {
        const productId = button.getAttribute('data-offer-id');
        const price = button.getAttribute('data-price');

        if (!productId && !price) {
            return;
        }

        if (button.classList.contains('is-active')) {
            this.addFavoritesProduct(productId, price);
        } else {
            this.removeFavoritesProduct(productId);
        }
    }

    trackCategoryView() {
        const url = window.location.href;
        const categoryMatch = url.match(/planirovki-i-ceny\/([^?]+)/);

        if (categoryMatch && categoryMatch[1]) {
            const categorySlug = categoryMatch[1];
            const categoryId = this.slugToId(categorySlug);

            this.handleCategoryView(String(categoryId));
        }
    }

    // значения ID берем из yml выгрузки, например https://yuntolovo.glavstroy-spb.ru/storage/markets/YML_yandex_yuntolovo.xml
    slugToId(slug) {
        const ids = {
            studii            : '100',
            '1-komnatnye'     : '101',
            '2-komnatnye'     : '102',
            '2-komnatnye-euro': '103',
            '3-komnatnye'     : '104',
            '3-komnatnye-euro': '105',
            '4-komnatnye'     : '106',
            '4-komnatnye-euro': '107'
        };

        return ids[slug] || slug;
    }

    handleCategoryView(categoryId) {
        mindbox('async', {
            operation: 'ProsmotrKategoriiYu',
            data     : {
                customer: {
                    area: {
                        ids: {
                            externalId: 'ru'
                        }
                    }
                },
                viewProductCategory: {
                    productCategory: {
                        ids: {
                            website: categoryId
                        }
                    }
                }
            },
            onError(error) {
                console.error('Mindbox error:', error);
            }
        });
    }
}

export default MindboxManager;
